import AllTickets from "../../components/AllEvents";

type Props = {};

const AllEvents = (props: Props) => {
  return <AllTickets />;
};

export default AllEvents;
